// extracted by mini-css-extract-plugin
export var active = "_fw-7";
export var blink = "_fw-8";
export var dropDownSelector = "_fw-4";
export var dropDownWrapper = "_fw-3";
export var fakeCursor = "_fw-6";
export var fontSizeButton = "_fw-9";
export var formQuillEditor = "_fw-0";
export var pressed = "_fw-a";
export var qlBlank = "_fw-1";
export var textFormattingToolbar = "_fw-2";
export var textToolbarOption = "_fw-5";